import src from "IMAGE";
export default { src, width: 98, height: 98, blurWidth: 0, blurHeight: 0};
